// ═══════════════════════════════
// DATA
// ═══════════════════════════════
const questions = [
  {
    id: 'cheveux',
    title: 'Quelle est ta couleur de cheveux naturelle ?',
    subtitle: 'Avant toute coloration — ou ta couleur actuelle.',
    cols: 'cols-2',
    options: [
      { value:'blond_dore',    label:'Blond doré / miel',      desc:'Reflets chauds lumineux',      swatch:'#D4A843', s:{P:3,E:0,A:1,H:0} },
      { value:'blond_cendre',  label:'Blond cendré / platine', desc:'Reflets froids, quasi blanc',  swatch:'#D8D0C0', s:{P:0,E:3,A:0,H:1} },
      { value:'chatain_chaud', label:'Châtain / brun chaud',   desc:'Reflets dorés ou roux',        swatch:'#7B4F2E', s:{P:2,E:0,A:3,H:0} },
      { value:'chatain_froid', label:'Châtain / brun froid',   desc:'Reflets cendrés ou mats',      swatch:'#5C4033', s:{P:0,E:1,A:0,H:3} },
      { value:'roux',          label:'Roux / auburn',          desc:'Cuivre, cannelle, acajou',     swatch:'#B5451B', s:{P:1,E:0,A:3,H:0} },
      { value:'noir',          label:'Noir',                   desc:'Noir pur ou très foncé',       swatch:'#1A1410', s:{P:0,E:0,A:1,H:3} },
    ]
  },
  {
    id: 'yeux',
    title: 'Quelle est ta couleur d\'yeux ?',
    subtitle: 'Regarde de près — parfois ils ont des nuances surprenantes.',
    cols: 'cols-3',
    options: [
      { value:'bleu_clair',  label:'Bleu clair',       desc:'Azur, glacier',    swatch:'#A8C8E8', s:{P:0,E:3,A:0,H:1} },
      { value:'bleu_fonce',  label:'Bleu foncé',       desc:'Marine, saphir',   swatch:'#3B6B9E', s:{P:0,E:1,A:0,H:3} },
      { value:'vert',        label:'Vert',             desc:'Émeraude, sauge',  swatch:'#5A8C5A', s:{P:2,E:1,A:2,H:0} },
      { value:'noisette',    label:'Noisette',         desc:'Ambré, bronze',    swatch:'#8B6340', s:{P:2,E:0,A:3,H:0} },
      { value:'marron',      label:'Marron foncé',     desc:'Chocolat, brun',   swatch:'#4A2E1A', s:{P:0,E:0,A:2,H:3} },
      { value:'gris',        label:'Gris / bleu-gris', desc:'Acier, perle',     swatch:'#9DAAB2', s:{P:0,E:3,A:0,H:1} },
    ]
  },
  {
    id: 'peau',
    title: 'Comment décrirais-tu le teint de ta peau ?',
    subtitle: 'Carnation naturelle, sans maquillage ni bronzage.',
    cols: 'cols-2',
    options: [
      { value:'tres_claire',    label:'Très claire, presque rosée',  desc:'Sous-tons roses',           swatch:'#F5E0D8', s:{P:1,E:3,A:0,H:1} },
      { value:'claire_peche',   label:'Claire avec reflet pêche',    desc:'Sous-tons chauds et dorés', swatch:'#F0C9A0', s:{P:3,E:0,A:1,H:0} },
      { value:'moy_chaude',     label:'Moyenne / dorée',             desc:'Teint lumineux, hâlé',      swatch:'#D4956B', s:{P:2,E:0,A:3,H:0} },
      { value:'moy_froide',     label:'Moyenne / rosée ou cendrée',  desc:'Sous-tons froids',          swatch:'#C9A898', s:{P:0,E:2,A:0,H:2} },
      { value:'mate',           label:'Mate / dorée ou olive',       desc:'Sous-tons miel',            swatch:'#B07040', s:{P:0,E:0,A:3,H:1} },
      { value:'foncee',         label:'Foncée / ébène',              desc:'Profonde, chaude ou froide',swatch:'#5C3020', s:{P:0,E:0,A:2,H:3} },
    ]
  },
  {
    id: 'veines',
    title: 'Regarde tes veines au poignet à la lumière du jour.',
    subtitle: 'Quelle couleur dominante vois-tu ?',
    cols: 'cols-1',
    options: [
      { value:'bleu_violet', label:'Bleues / violettes',  desc:'Sous-tons froids — probablement cool', emoji:'💙', s:{P:0,E:3,A:0,H:3} },
      { value:'vert',        label:'Vertes',              desc:'Vert ou vert-jaune — probablement warm', emoji:'💚', s:{P:3,E:0,A:3,H:0} },
      { value:'mixte',       label:'Mélange bleu-vert',   desc:'Difficile à dire — tu pourrais être neutre', emoji:'🩵', s:{P:1,E:1,A:1,H:1} },
    ]
  },
  {
    id: 'soleil',
    title: 'Comment réagit ta peau au soleil ?',
    subtitle: 'Sans protection solaire, après une première exposition.',
    cols: 'cols-1',
    options: [
      { value:'brule_fort',   label:'Je brûle très vite',              desc:'Rougeurs, jamais de bronzage',          emoji:'🔴', s:{P:0,E:3,A:0,H:1} },
      { value:'brule_peu',    label:'Je rougis puis bronze légèrement', desc:'Bronzage discret, doré ou rosé',        emoji:'🌸', s:{P:2,E:2,A:0,H:0} },
      { value:'bronze_vite',  label:'Je bronze assez vite',            desc:'Bronzage doré ou ambré naturel',        emoji:'🌟', s:{P:3,E:0,A:1,H:0} },
      { value:'bronze_fonce', label:'Je bronze profondément',          desc:'Peau qui absorbe le soleil facilement', emoji:'☀️', s:{P:0,E:0,A:3,H:2} },
    ]
  },
  {
    id: 'levres',
    title: 'Regarde la couleur naturelle de tes lèvres sans maquillage.',
    subtitle: 'Observe sous une bonne lumière naturelle — c\'est un marqueur clé utilisé par les colorimétriciens.',
    cols: 'cols-1',
    options: [
      { value:'rose_vif',    label:'Rose vif / framboise',   desc:'Lèvres nettement roses, presque rosées ou fuchsia',           swatch:'#E87090', s:{P:0,E:3,A:0,H:2} },
      { value:'rose_nude',   label:'Rose pâle / nude rosé',  desc:'Rose discret, presque beige-rosé, très doux',                swatch:'#E8B8B0', s:{P:1,E:2,A:0,H:1} },
      { value:'peche_corail',label:'Pêche / corail',         desc:'Teinte chaude, entre l\'orange et le rose, lumineuse',        swatch:'#F09070', s:{P:3,E:0,A:1,H:0} },
      { value:'brun_nude',   label:'Nude / brun rosé',       desc:'Teinte terre, brune ou brun-rosé, peu de rose pur',           swatch:'#C08878', s:{P:1,E:0,A:3,H:1} },
      { value:'brun_fonce',  label:'Brun foncé / bordeaux naturel', desc:'Lèvres très pigmentées, prune, bordeaux ou brun profond', swatch:'#8B3A4A', s:{P:0,E:0,A:2,H:3} },
    ]
  },
  {
    id: 'poignet',
    title: 'Regarde la face interne de ton poignet à la lumière naturelle.',
    subtitle: "C'est la zone la moins exposée au soleil — elle révèle ta vraie carnation sans bronzage.",
    cols: 'cols-1',
    options: [
      {value:'rose_lait',   label:'Rose nacré / lait frais',   desc:'Peau très claire avec reflets rosés ou bleutés',            emoji:'🤍', s:{P:0,E:3,A:0,H:1}},
      {value:'peche_clair', label:'Pêche / crème légère',      desc:'Fond clair avec un voile chaud, ni froid ni trop doré',     emoji:'🍑', s:{P:3,E:0,A:1,H:0}},
      {value:'beige_dore',  label:'Beige doré / miel',         desc:'Fond chaud visible, teint lumineux même sans soleil',       emoji:'✨', s:{P:2,E:0,A:3,H:0}},
      {value:'olive_brun',  label:'Olive / brun naturel',      desc:'Peau naturellement foncée avec sous-tons chauds',          emoji:'🌿', s:{P:0,E:0,A:2,H:2}},
      {value:'rose_froid',  label:'Rosé / légèrement violacé', desc:'Transparence avec reflets froids, veines très visibles',   emoji:'💜', s:{P:0,E:2,A:0,H:3}},
    ]
  },
  {
    id: 'bronzage',
    title: "En fin d'été, comment évolue ta peau après plusieurs semaines de soleil ?",
    subtitle: "Le bronzage révèle la profondeur naturelle de ta peau — indépendamment de ta couleur de base.",
    cols: 'cols-1',
    options: [
      {value:'reste_claire',   label:'Presque pas de différence',           desc:'Mon teint change à peine, je bronze très peu',                emoji:'☁️',  s:{P:0,E:3,A:0,H:0}, d:-2},
      {value:'dore_leger',     label:'Un léger hâle doré ou rosé',          desc:'Bronzage discret, très clair et éphémère',                    emoji:'🌤️', s:{P:2,E:1,A:0,H:0}, d:-1},
      {value:'bronze_dore',    label:'Un beau bronzage doré et lumineux',   desc:'Teint doré homogène, je garde une belle mine longtemps',      emoji:'☀️',  s:{P:2,E:0,A:2,H:0}, d:1},
      {value:'bronze_profond', label:'Un bronzage profond et intense',      desc:"Mon bronzage est très foncé et dure jusqu'en hiver",         emoji:'🌞',  s:{P:0,E:0,A:2,H:2}, d:3},
    ]
  },
  {
    id: 'contraste',
    title: "Quel est le contraste naturel entre ta peau, tes cheveux et tes yeux ?",
    subtitle: "Observe l'ensemble sans maquillage — c'est le contraste global qui compte.",
    cols: 'cols-1',
    options: [
      {value:'contraste_fort',  label:'Contraste très marqué',  desc:'Ex : peau très claire + cheveux noirs / peau très foncée + yeux clairs — le contraste est saisissant',   emoji:'⚡', s:{P:0,E:0,A:0,H:3}, b:3},
      {value:'contraste_moyen', label:'Contraste équilibré',    desc:'Ex : peau moyenne + cheveux châtains + yeux marron — tout est harmonieux, ni criant ni effacé',         emoji:'🌗', s:{P:1,E:1,A:1,H:1}, b:0},
      {value:'contraste_doux',  label:'Contraste très doux',    desc:'Ex : peau claire + cheveux blonds + yeux clairs / peau dorée + cheveux bruns doux — tout se fond',      emoji:'🌫️', s:{P:1,E:2,A:2,H:0}, b:-2},
    ]
  }
];

// ═══════════════════════════════
// CONFIG — À PERSONNALISER
// ═══════════════════════════════
const CONFIG = {
  // Clé publique Klaviyo (commence par "pk_" dans Klaviyo > Account > API Keys)
  KLAVIYO_PUBLIC_KEY: 'TON_API_KEY_KLAVIYO_ICI',
  // URL de ta boutique Shopify (sans slash final)
  SHOPIFY_URL: 'https://ton-boutique.myshopify.com',
  // Nom du paramètre filtre couleur Shopify (dans Settings > Search & Discovery > Filters)
  SHOPIFY_COLOR_FILTER: 'filter.p.m.custom.couleur',
};

// Couleurs par saison → valeurs EXACTES de tes filtres Shopify (à adapter à ta boutique)
const SEASON_SHOPIFY_COLORS = {
  P: ['Peche','Corail','Camel','Ivoire','Saumon','Abricot'],
  E: ['Lavande','Rose','Mauve','Bleu','Menthe','Parme'],
  A: ['Terracotta','Camel','Bordeaux','Kaki','Moutarde','Rouille'],
  H: ['Noir','Blanc','Rouge','Cobalt','Fuchsia','Emeraude'],
};

// ═══════════════════════════════
// STATE
// ═══════════════════════════════
let currentQ = 0, answers = {}, userPrenom = '', userEmail = '', aiResults = null;

function showScreen(id) {
  document.querySelectorAll('.screen').forEach(s => { s.classList.remove('active'); s.style.display='none'; });
  const el = document.getElementById('screen-'+id);
  el.style.display = 'flex';
  requestAnimationFrame(() => el.classList.add('active'));
}

function updateProgress() {
  document.getElementById('progress-fill').style.width = (currentQ/questions.length*100)+'%';
}

function startQuiz() { currentQ=0; showScreen('question'); renderQuestion(); }

function goBack() {
  if (currentQ > 0) { currentQ--; renderQuestion(); }
}

function renderQuestion() {
  const q = questions[currentQ];
  updateProgress();
  var backBtn = document.getElementById('btn-back');
  if (backBtn) backBtn.style.display = currentQ > 0 ? 'inline-block' : 'none';
  document.getElementById('q-counter').textContent = `Question ${currentQ+1} / ${questions.length}`;
  document.getElementById('q-title').textContent = q.title;
  document.getElementById('q-subtitle').textContent = q.subtitle;

  // Preambule Q1
  var preambule = document.getElementById('q-preambule');
  if (!preambule) {
    preambule = document.createElement('div');
    preambule.id = 'q-preambule';
    var optC = document.getElementById('options-container');
    optC.parentNode.insertBefore(preambule, optC);
  }
  if (currentQ === 0) {
    preambule.innerHTML = [
      ""
    ].join('');
  } else {
    preambule.innerHTML = '';
  }
  const c = document.getElementById('options-container');
  c.className = 'options-grid '+q.cols;
  c.innerHTML = '';
  q.options.forEach(opt => {
    const div = document.createElement('div');
    div.className = 'option-card'+(answers[q.id]===opt.value?' selected':'');
    div.onclick = () => selectOption(q.id, opt.value, div);
    const vis = opt.swatch
      ? `<svg class="option-swatch" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg"><circle cx="18" cy="18" r="16" fill="${opt.swatch}" stroke="white" stroke-width="2"/></svg>`
      : `<span class="option-emoji">${opt.emoji}</span>`;
    div.innerHTML = `${vis}
      <span class="option-text">
        <span class="option-label">${opt.label}</span>
        <span class="option-desc">${opt.desc}</span>
      </span>
      <span class="option-check"><svg viewBox="0 0 12 12" fill="none" stroke="white" stroke-width="2.2"><polyline points="1.5,6 5,9.5 10.5,2.5"/></svg></span>`;
    c.appendChild(div);
  });
  // Appliquer couleurs swatches options
}

function selectOption(qId, val, el) {
  answers[qId] = val;
  document.querySelectorAll('.option-card').forEach(c => c.classList.remove('selected'));
  el.classList.add('selected');
  setTimeout(() => {
    currentQ++;
    if (currentQ < questions.length) renderQuestion();
    else showEmailScreen();
  }, 380);
}

function computeSeason() {
  // ── Axe 1 : Grande saison (P/E/A/H) ──────────────────────────────────────
  const sc = {P:0, E:0, A:0, H:0};
  questions.forEach(q => {
    const opt = q.options.find(o => o.value===answers[q.id]);
    if (opt) Object.entries(opt.s).forEach(([k,v]) => { if(sc[k]!==undefined) sc[k]+=v; });
  });
  const base = Object.entries(sc).sort((a,b)=>b[1]-a[1])[0][0];

  // ── Axe 2 : Profondeur (deep vs light) ─────────────────────────────────
  const chevVal = answers['cheveux'];
  const depthFromHair = {noir:3, chatain_chaud:2, chatain_froid:2, roux:1, blond_dore:-1, blond_cendre:-2}[chevVal] || 0;
  const yeuxVal = answers['yeux'];
  const depthFromEyes = {marron:2, bleu_fonce:1, noisette:1, vert:0, gris:-1, bleu_clair:-2}[yeuxVal] || 0;
  const peauVal = answers['peau'];
  const depthFromPeau = {foncee:3, mate:2, moy_chaude:1, moy_froide:0, claire_peche:-1, tres_claire:-2}[peauVal] || 0;
  const bronzageOpt = questions.find(q=>q.id==='bronzage')?.options.find(o=>o.value===answers['bronzage']);
  const depthFromBronzage = bronzageOpt?.d || 0;
  const depth = depthFromHair + depthFromEyes + depthFromPeau + depthFromBronzage;

  // ── Axe 3 : Éclat (bright vs muted) ──────────────────────────────────────
  const veinesVal = answers['veines'];
  const brightFromVeines = {bleu_violet:2, vert:-1, mixte:0}[veinesVal] || 0;
  const levresVal = answers['levres'];
  const brightFromLevres = {rose_vif:2, rose_nude:0, peche_corail:1, brun_nude:-1, brun_fonce:-1}[levresVal] || 0;
  const contrasteOpt = questions.find(q=>q.id==='contraste')?.options.find(o=>o.value===answers['contraste']);
  const brightFromContraste = contrasteOpt?.b || 0;
  const poignetVal = answers['poignet'];
  const brightFromPoignet = {rose_lait:1, peche_clair:0, beige_dore:-1, olive_brun:-1, rose_froid:2}[poignetVal] || 0;
  const bright = brightFromVeines + brightFromLevres + brightFromContraste + brightFromPoignet;

  // ── Mapping vers les 12 sous-saisons ─────────────────────────────────────
  const subSeasons = {
    P: () => {
      if (bright > 2)  return 'Printemps Lumineux';   // chaud + vif + clair
      if (depth > 1)   return 'Printemps Chaud';       // chaud + profond
      return                  'Printemps Clair';        // chaud + clair + doux
    },
    E: () => {
      if (depth < -1)  return 'Été Clair';             // froid + très clair
      if (bright > 1)  return 'Été Froid';             // froid + net
      return                  'Été Doux';               // froid + doux + muted
    },
    A: () => {
      if (depth > 2)   return 'Automne Profond';       // chaud + très profond
      if (bright < -1) return 'Automne Doux';          // chaud + muted + terreux
      return                  'Automne Chaud';          // chaud + medium
    },
    H: () => {
      if (depth > 2)   return 'Hiver Profond';         // froid + très profond
      if (bright > 2)  return 'Hiver Pur';             // froid + très vif + contrasté
      return                  'Hiver Froid';            // froid + net + medium
    },
  };

  return { base, sub: subSeasons[base](), depth, bright };
}

function showEmailScreen() {
  document.getElementById('progress-fill').style.width='95%';
  const { base: season } = computeSeason();
  const prev = {P:['#F4A460','#DDA853','#F2C4A0','#E8896A','#C9D98C'],E:['#B0C4DE','#C5A3B5','#A8D0D0','#D4B8D0','#E8D4E0'],A:['#8B4513','#C17A40','#6B8E23','#B8762E','#D4916B'],H:['#2C3E6B','#8B1A2C','#1A3A2A','#3C2060','#C8102E']};
  document.getElementById('preview-swatches').innerHTML = (prev[season]||prev.E).map(c=>`<div class="preview-swatch" style="background:${c}"></div>`).join('');
  showScreen('email');
}

async function submitEmail() {
  const prenom = document.getElementById('input-prenom').value.trim();
  const email  = document.getElementById('input-email').value.trim();
  const errEl  = document.getElementById('email-error');
  errEl.style.display='none';
  if (!prenom) { errEl.textContent='Entre ton prénom 🙏'; errEl.style.display='block'; return; }
  if (!email||!email.includes('@')) { errEl.textContent='Adresse email invalide 🙏'; errEl.style.display='block'; return; }
  userPrenom=prenom.charAt(0).toUpperCase()+prenom.slice(1); userEmail=email;
  subscribeToNewsletter(email, userPrenom);
  showScreen('loading');
  document.getElementById('progress-fill').style.width='98%';
  animateLoading();
  await generateAI();
}

function animateLoading() {
  const steps = [
    'Analyse de tes réponses…',
    'Détection de ta saison colorimétrique…',
    'Génération de ta palette personnalisée…',
    'Recommandations style curvy…',
    'Finalisation de ton profil…',
  ];
  const bar   = document.getElementById('loading-bar');
  const pct   = document.getElementById('loading-pct');
  const label = document.getElementById('loading-label');
  let current = 0;
  const target = 92; // on s'arrête à 92% — les derniers % arrivent quand l'IA répond

  // Smooth % counter
  const interval = setInterval(() => {
    if (current >= target) { clearInterval(interval); return; }
    // Accélère au début, ralentit vers la fin
    const step = current < 40 ? 2 : current < 75 ? 1 : 0.4;
    current = Math.min(current + step, target);
    bar.style.width = current + '%';
    pct.textContent = Math.floor(current);
    // Update label at key milestones
    const stepIdx = Math.floor((current / target) * (steps.length - 1));
    label.textContent = steps[Math.min(stepIdx, steps.length - 1)];
  }, 80);

  // Store interval ref so generateAI can complete to 100%
  window._loadingInterval = interval;
}

function completeLoading() {
  clearInterval(window._loadingInterval);
  const bar = document.getElementById('loading-bar');
  const pct = document.getElementById('loading-pct');
  const label = document.getElementById('loading-label');
  bar.style.transition = 'width 0.6s ease';
  bar.style.width = '100%';
  pct.textContent = '100';
  label.textContent = 'Profil prêt !';
}

async function generateAI() {
  const { base: season, sub: subSeason } = computeSeason();
  const answersText = questions.map(q=>{
    const opt = q.options.find(o=>o.value===answers[q.id]);
    return `- ${q.title.replace('?','')}: ${opt?opt.label:'—'}`;
  }).join('\n');

  const prompt = `Tu es une experte en colorimétrie saisonnière (système 12 sous-saisons). L'utilisatrice s'appelle ${userPrenom}.

Ses réponses :
${answersText}
Sous-saison calculée par notre algorithme : ${subSeason}

Génère une analyse colorimétrique complète, chaleureuse et personnalisée. Réponds UNIQUEMENT en JSON valide, sans markdown, sans backticks :

{
  "saison": "Confirme ou affine la sous-saison parmi ces 12 exactement : Printemps Lumineux, Printemps Chaud, Printemps Clair, Été Doux, Été Clair, Été Froid, Automne Profond, Automne Chaud, Automne Doux, Hiver Pur, Hiver Profond, Hiver Froid",
  "emoji": "emoji représentant la saison",
  "headline": "Phrase poétique courte qui décrit cette saison (max 10 mots)",
  "description": "2-3 phrases personnalisées pour ${userPrenom}, ton bienveillant, en tutoyant",
  "palette_pe": [{"nom":"couleur","hex":"#XXXXXX"}, ... 8 couleurs printemps/été : légères, lumineuses, adaptées aux matières estivales],
  "palette_ah": [{"nom":"couleur","hex":"#XXXXXX"}, ... 8 couleurs automne/hiver : profondes, riches, pour matières chaudes],
  "couleurs_yes": ["6 couleurs qui illuminent"],
  "couleurs_no": ["4 couleurs à éviter"],
  "maquillage": "2 phrases concrètes sur le maquillage idéal",
  "style_tip": "Un conseil style spécifique pour les femmes curvy avec ce profil",
  "metal": "Or, Argent ou Or rose — avec justification courte",
  "message_perso": "Message chaleureux et motivant pour ${userPrenom} (2 phrases max)"
}`;

  try {
    const resp = await fetch('https://api.anthropic.com/v1/messages',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({model:'claude-sonnet-4-20250514',max_tokens:1000,messages:[{role:'user',content:prompt}]})
    });
    const data = await resp.json();
    const raw = data.content.map(b=>b.text||'').join('');
    aiResults = JSON.parse(raw.replace(/```json|```/g,'').trim());
    completeLoading();
    await new Promise(r=>setTimeout(r,700));
    renderResults();
  } catch(e) {
    const fb = {
      // ── PRINTEMPS ──────────────────────────────────────────────────────────
      'Printemps Lumineux': {
        saison:'Printemps Lumineux', emoji:'🌟', headline:'Lumineuse, pétillante, irrésistiblement vivante',
        description:`${userPrenom}, tu es la saison du contraste chaud et vif — ton teint s'illumine avec des couleurs chaudes ET intenses. Tu as besoin de couleurs qui ont de l'éclat, jamais trop ternes ni trop sombres.`,
        palette:[
          {nom:'Corail vif',hex:'#FF6B47',usage:'vêtements'},{nom:'Turquoise clair',hex:'#40E0D0',usage:'vêtements'},
          {nom:'Pêche lumineux',hex:'#FFAE78',usage:'vêtements'},{nom:'Vert pomme',hex:'#8DB600',usage:'accessoires'},
          {nom:'Jaune doré',hex:'#FFD700',usage:'accessoires'},{nom:'Saumon vif',hex:'#FF8C69',usage:'vêtements'},
          {nom:'Abricot intense',hex:'#F4A460',usage:'vêtements'},{nom:'Rouge tomate',hex:'#FF4500',usage:'maquillage'},
          {nom:'Rose corail',hex:'#F88379',usage:'maquillage'},{nom:'Blanc cassé chaud',hex:'#FFF8DC',usage:'vêtements'},
          {nom:'Camel clair',hex:'#D2A679',usage:'vêtements'},{nom:'Or poli',hex:'#CFB53B',usage:'accessoires'}
        ],
        couleurs_yes:['Corail vif','Turquoise','Pêche','Vert pomme','Saumon','Jaune doré'],
        couleurs_no:['Noir pur','Gris froid','Bordeaux profond','Beige terne'],
        maquillage:'Fond de teint doré ou pêché, jamais mat. Lèvres corail ou pêche vif — les nudes te font disparaître. Blush abricot sur les pommettes.',
        style_tip:'En curvy, mise sur le monochrome corail ou pêche-saumon : allonge et illumine simultanément. Évite les imprimés trop petits — choisis des motifs généreux à ta mesure.',
        metal:'Or — ton métal de naissance, il amplifie l\'éclat naturel de ta palette.',
        message_perso:`${userPrenom}, tu as le don rare de rendre les couleurs vivantes autour de toi. Porte du vif, porte de l'éclat — c'est exactement ce que ton corps demande.`,
        palette_pe:[{"nom": "Corail vif", "hex": "#FF6B47"}, {"nom": "Turquoise clair", "hex": "#40E0D0"}, {"nom": "Pêche lumineux", "hex": "#FFAE78"}, {"nom": "Jaune citron", "hex": "#FFF44F"}, {"nom": "Saumon vif", "hex": "#FF8C69"}, {"nom": "Rose abricot", "hex": "#F88379"}, {"nom": "Blanc cassé chaud", "hex": "#FFF8DC"}, {"nom": "Vert pomme", "hex": "#8DB600"}],
        palette_ah:[{"nom": "Terracotta vif", "hex": "#C66B3B"}, {"nom": "Camel doré", "hex": "#C19A6B"}, {"nom": "Rouille claire", "hex": "#CB6D51"}, {"nom": "Moutarde", "hex": "#C4A000"}, {"nom": "Brun roux", "hex": "#A0522D"}, {"nom": "Orange brûlé", "hex": "#CC5500"}, {"nom": "Kaki doré", "hex": "#8B8040"}, {"nom": "Bronze cuivré", "hex": "#B87333"}]
      },
      'Printemps Chaud': {
        saison:'Printemps Chaud', emoji:'🌻', headline:'Chaude, dorée, rayonnante comme midi',
        description:`${userPrenom}, tu es la version la plus chaude et terrienne du Printemps. Tes couleurs sont ensoleillées et riches, avec une vraie profondeur qui te distingue des autres profils printaniers.`,
        palette:[
          {nom:'Camel doré',hex:'#C19A6B',usage:'vêtements'},{nom:'Abricot chaud',hex:'#F08040',usage:'vêtements'},
          {nom:'Terracotta clair',hex:'#E07050',usage:'vêtements'},{nom:'Vert olive chaud',hex:'#9B8B4B',usage:'vêtements'},
          {nom:'Bronze doré',hex:'#B8860B',usage:'accessoires'},{nom:'Brun roux',hex:'#A0522D',usage:'vêtements'},
          {nom:'Pêche foncée',hex:'#D4826A',usage:'vêtements'},{nom:'Moutarde claire',hex:'#DAA520',usage:'accessoires'},
          {nom:'Saumon doré',hex:'#E8956A',usage:'maquillage'},{nom:'Ivoire doré',hex:'#F5ECD7',usage:'vêtements'},
          {nom:'Rouille clair',hex:'#CB6D51',usage:'vêtements'},{nom:'Or rosé',hex:'#C5985A',usage:'accessoires'}
        ],
        couleurs_yes:['Camel','Abricot','Terracotta clair','Olive','Bronze','Brun roux'],
        couleurs_no:['Blanc pur froid','Gris acier','Bleu marine froid','Noir'],
        maquillage:'Base teint dorée ou miel. Lèvres dans les brun-pêché ou terracotta clair. Fard à paupières bronze ou brun chaud.',
        style_tip:'Le camel total look est ta tenue signature — de la tête aux pieds dans les dorés et terracottas clairs. En curvy, une ceinture dans les tons bronze crée la taille sans rupture de couleur.',
        metal:'Or — exclusivement. L\'argent te donne l\'air fade.',
        message_perso:`${userPrenom}, tu irradies une chaleur naturelle que peu de femmes ont. Embrasse tes tons dorés — ils sont exactement à ton image.`,
        palette_pe:[{"nom": "Abricot chaud", "hex": "#F08040"}, {"nom": "Pêche foncée", "hex": "#D4826A"}, {"nom": "Saumon doré", "hex": "#E8956A"}, {"nom": "Ivoire doré", "hex": "#F5ECD7"}, {"nom": "Vert olive clair", "hex": "#9B8B4B"}, {"nom": "Corail pêche", "hex": "#F4A460"}, {"nom": "Blanc cassé", "hex": "#FFF8E7"}, {"nom": "Turquoise chaud", "hex": "#48CACA"}],
        palette_ah:[{"nom": "Camel profond", "hex": "#A07040"}, {"nom": "Terracotta", "hex": "#C66B3B"}, {"nom": "Brun roux", "hex": "#A0522D"}, {"nom": "Rouille", "hex": "#CB6D51"}, {"nom": "Moutarde dorée", "hex": "#DAA520"}, {"nom": "Chocolat lait", "hex": "#7B4F2E"}, {"nom": "Kaki chaud", "hex": "#8B8040"}, {"nom": "Bronze doré", "hex": "#B8860B"}]
      },
      'Printemps Clair': {
        saison:'Printemps Clair', emoji:'🌸', headline:'Délicate, lumineuse, fraîche comme l\'aube',
        description:`${userPrenom}, tu es le Printemps dans sa version la plus douce et lumineuse. Ton profil clair demande des couleurs légères, jamais surchargées — la subtilité est ta force.`,
        palette:[
          {nom:'Rose pêche pâle',hex:'#FFCBA4',usage:'vêtements'},{nom:'Ivoire chaud',hex:'#FFFFF0',usage:'vêtements'},
          {nom:'Menthe chaude',hex:'#98FB98',usage:'vêtements'},{nom:'Pêche nacré',hex:'#FFDAB9',usage:'vêtements'},
          {nom:'Bleu ciel chaud',hex:'#87CEEB',usage:'accessoires'},{nom:'Lilas rosé',hex:'#E8D5E0',usage:'vêtements'},
          {nom:'Corail pâle',hex:'#F4A9A8',usage:'vêtements'},{nom:'Camel clair',hex:'#D2B48C',usage:'accessoires'},
          {nom:'Rose abricot',hex:'#F7CAC9',usage:'maquillage'},{nom:'Jaune beurre',hex:'#FFFACD',usage:'vêtements'},
          {nom:'Vert tendre',hex:'#B5D5C5',usage:'vêtements'},{nom:'Blanc cassé',hex:'#FAF0E6',usage:'vêtements'}
        ],
        couleurs_yes:['Rose pêche','Ivoire','Menthe','Pêche','Bleu ciel','Corail pâle'],
        couleurs_no:['Noir','Bordeaux profond','Kaki sombre','Orange vif'],
        maquillage:'Base très légère, effet seconde peau. Lèvres rose pêche ou nude rosé — les couleurs trop intenses t\'écrasent. Blush très léger, presque transparent.',
        style_tip:'Les matières fluides et légères (mousseline, viscose) dans tes tons clairs te mettent en valeur. En curvy, un ensemble clair monochrome est ta combinaison la plus élégante.',
        metal:'Or rose — il harmonise parfaitement tes sous-tons chauds et ta légèreté naturelle.',
        message_perso:`${userPrenom}, ta beauté est celle de la douceur lumineuse — ne la couvre jamais de couleurs trop lourdes. Ta palette est un poème pastel.`,
        palette_pe:[{"nom": "Rose pêche pâle", "hex": "#FFCBA4"}, {"nom": "Pêche nacré", "hex": "#FFDAB9"}, {"nom": "Menthe chaude", "hex": "#98FB98"}, {"nom": "Bleu ciel chaud", "hex": "#87CEEB"}, {"nom": "Corail pâle", "hex": "#F4A9A8"}, {"nom": "Lilas rosé", "hex": "#E8D5E0"}, {"nom": "Jaune beurre", "hex": "#FFFACD"}, {"nom": "Blanc cassé", "hex": "#FAF0E6"}],
        palette_ah:[{"nom": "Camel clair", "hex": "#D2B48C"}, {"nom": "Rose abricot moyen", "hex": "#F7CAC9"}, {"nom": "Vert tendre", "hex": "#B5D5C5"}, {"nom": "Lavande chaude", "hex": "#E6D0F0"}, {"nom": "Bleu ciel doux", "hex": "#B0D4E8"}, {"nom": "Pêche profonde", "hex": "#D4826A"}, {"nom": "Sable doré", "hex": "#C8A882"}, {"nom": "Ivoire chaud", "hex": "#F5ECD7"}]
      },
      // ── ÉTÉ ───────────────────────────────────────────────────────────────
      'Été Doux': {
        saison:'Été Doux', emoji:'🌊', headline:'Douce, poétique, intemporellement raffinée',
        description:`${userPrenom}, tu es la quintessence de l'Été — teintes froides, poudrées, jamais criardes. Ta beauté est celle de la grâce discrète qui ne crie pas mais qui captive.`,
        palette:[
          {nom:'Lavande rosée',hex:'#E6B8D8',usage:'vêtements'},{nom:'Rose poudré',hex:'#F2C5C8',usage:'vêtements'},
          {nom:'Mauve doux',hex:'#D8A8D0',usage:'vêtements'},{nom:'Bleu brume',hex:'#B0C8D8',usage:'vêtements'},
          {nom:'Gris perle rosé',hex:'#D4C8CC',usage:'vêtements'},{nom:'Menthe froide',hex:'#B0D8C8',usage:'accessoires'},
          {nom:'Parme poudré',hex:'#C090C0',usage:'vêtements'},{nom:'Taupe rosé',hex:'#C8B0B0',usage:'vêtements'},
          {nom:'Framboise douce',hex:'#E87090',usage:'maquillage'},{nom:'Blanc rosé',hex:'#FFF0F0',usage:'vêtements'},
          {nom:'Bleu ardoise',hex:'#8098B0',usage:'accessoires'},{nom:'Crème froide',hex:'#F8F5F5',usage:'vêtements'}
        ],
        couleurs_yes:['Lavande','Rose poudré','Mauve','Bleu brume','Parme','Framboise'],
        couleurs_no:['Orange','Camel','Kaki','Marron chaud','Jaune vif'],
        maquillage:'Base rosée ou beige-rose. Lèvres rose framboise ou mauve — jamais nude beige qui te fait disparaître. Blush rose froid très doux.',
        style_tip:'Le total look parme ou bleu-gris est ta signature en curvy — il allonge ET met en valeur ton profil délicat. Préfère les matières fluides qui tombent bien.',
        metal:'Argent — il amplifie la fraîcheur naturelle de ta palette.',
        message_perso:`${userPrenom}, ta palette est celle de la poésie — subtile, raffinée, et d'une beauté qui dure. Porte tes tons poudrés avec la fierté qu'ils méritent.`,
        palette_pe:[{"nom": "Lavande rosée", "hex": "#E6B8D8"}, {"nom": "Rose poudré", "hex": "#F2C5C8"}, {"nom": "Menthe froide", "hex": "#B0D8C8"}, {"nom": "Bleu brume", "hex": "#B0C8D8"}, {"nom": "Parme pâle", "hex": "#DDD0E8"}, {"nom": "Lilas doux", "hex": "#D8C8E8"}, {"nom": "Blanc rosé", "hex": "#FFF0F0"}, {"nom": "Rose quartz", "hex": "#F7CAD0"}],
        palette_ah:[{"nom": "Mauve doux", "hex": "#D8A8D0"}, {"nom": "Parme poudré", "hex": "#C090C0"}, {"nom": "Bleu ardoise", "hex": "#8098B0"}, {"nom": "Taupe rosé", "hex": "#C8B0B0"}, {"nom": "Framboise douce", "hex": "#E87090"}, {"nom": "Prune clair", "hex": "#906080"}, {"nom": "Gris perle rosé", "hex": "#D4C8CC"}, {"nom": "Bordeaux rosé", "hex": "#A04060"}]
      },
      'Été Clair': {
        saison:'Été Clair', emoji:'☁️', headline:'Claire, lumineuse, délicate comme la brume',
        description:`${userPrenom}, tu es la version la plus lumineuse et aérienne de l'Été. Ton profil très clair demande des couleurs légères et fraîches — la clarté est ta signature, jamais l'intensité.`,
        palette:[
          {nom:'Blanc rosé',hex:'#FFF0F5',usage:'vêtements'},{nom:'Rose pâle froid',hex:'#FFD1DC',usage:'vêtements'},
          {nom:'Lavande très pâle',hex:'#EDE0FF',usage:'vêtements'},{nom:'Bleu glacier',hex:'#D4EEF7',usage:'vêtements'},
          {nom:'Gris argent clair',hex:'#E8ECEF',usage:'vêtements'},{nom:'Menthe pâle',hex:'#D4EFDF',usage:'accessoires'},
          {nom:'Mauve nacré',hex:'#E8D5E8',usage:'vêtements'},{nom:'Crème froide',hex:'#FFFFF8',usage:'vêtements'},
          {nom:'Rose quartz',hex:'#F7CAD0',usage:'maquillage'},{nom:'Lilas poudré',hex:'#D8C8E8',usage:'vêtements'},
          {nom:'Bleu perle',hex:'#C8D8E8',usage:'accessoires'},{nom:'Parme très doux',hex:'#DDD0E8',usage:'vêtements'}
        ],
        couleurs_yes:['Blanc rosé','Rose pâle','Lavande très pâle','Bleu glacier','Mauve nacré','Parme'],
        couleurs_no:['Noir','Bordeaux','Orange','Couleurs très saturées','Brun'],
        maquillage:'Base ultra légère, effet peau nue. Lèvres rose pâle ou nude-rose très frais. Jamais de rouge ou bordeaux — trop intense pour ton profil.',
        style_tip:'Tes teintes claires monochrome créent une silhouette harmonieuse et allongée. En curvy, une robe ou ensemble dans tes tons pâles avec un accessoire argent est ta combinaison parfaite.',
        metal:'Argent ou or blanc — ils respectent la légèreté de ta palette.',
        message_perso:`${userPrenom}, tu as une beauté éthérée et lumineuse qui ne demande pas à être criarde. La clarté, c'est ton superpouvoir.`,
        palette_pe:[{"nom": "Blanc rosé", "hex": "#FFF0F5"}, {"nom": "Rose pâle froid", "hex": "#FFD1DC"}, {"nom": "Lavande très pâle", "hex": "#EDE0FF"}, {"nom": "Bleu glacier", "hex": "#D4EEF7"}, {"nom": "Menthe pâle", "hex": "#D4EFDF"}, {"nom": "Parme très doux", "hex": "#DDD0E8"}, {"nom": "Crème froide", "hex": "#FFFFF8"}, {"nom": "Lilas nacré", "hex": "#E8D5E8"}],
        palette_ah:[{"nom": "Gris argent", "hex": "#E8ECEF"}, {"nom": "Mauve nacré", "hex": "#E8D5E8"}, {"nom": "Bleu perle", "hex": "#C8D8E8"}, {"nom": "Lilas poudré", "hex": "#D8C8E8"}, {"nom": "Rose quartz", "hex": "#F7CAD0"}, {"nom": "Bleu gris doux", "hex": "#B8C8D8"}, {"nom": "Blanc cassé froid", "hex": "#F8F8FF"}, {"nom": "Parme clair", "hex": "#D8C8F0"}]
      },
      'Été Froid': {
        saison:'Été Froid', emoji:'🧊', headline:'Fraîche, précise, élégamment froide',
        description:`${userPrenom}, tu combines la douceur de l'Été avec une netteté froide plus marquée. Tes couleurs ont besoin d'une clarté froide et d'un certain contraste — ni trop doux, ni trop intense.`,
        palette:[
          {nom:'Framboise froid',hex:'#C72060',usage:'vêtements'},{nom:'Bleu acier',hex:'#7090B0',usage:'vêtements'},
          {nom:'Mauve moyen',hex:'#B070B0',usage:'vêtements'},{nom:'Rose framboise',hex:'#E06080',usage:'vêtements'},
          {nom:'Gris bleuté',hex:'#8090A0',usage:'vêtements'},{nom:'Parme soutenu',hex:'#A080C0',usage:'accessoires'},
          {nom:'Bleu lavande',hex:'#8090D0',usage:'vêtements'},{nom:'Bordeaux rosé',hex:'#A04060',usage:'vêtements'},
          {nom:'Rose fuchsia doux',hex:'#D060A0',usage:'maquillage'},{nom:'Blanc froid',hex:'#F8F8FF',usage:'vêtements'},
          {nom:'Gris perle froid',hex:'#C0C8D0',usage:'accessoires'},{nom:'Prune clair',hex:'#906080',usage:'vêtements'}
        ],
        couleurs_yes:['Framboise','Bleu acier','Mauve','Rose fuchsia','Gris bleuté','Parme'],
        couleurs_no:['Orange','Jaune','Camel','Brun chaud','Vert kaki'],
        maquillage:'Base rosée froide. Lèvres framboise ou rose fuchsia — tes couleurs ont besoin d\'un peu de mordant. Rouge à lèvres froid plutôt que chaud.',
        style_tip:'Le contraste froid est ton atout : bleu et framboise ensemble te donnent une allure sophistiquée. En curvy, joue la verticalité avec des tons bleutés sombres en bas et clairs en haut.',
        metal:'Argent — uniquement, l\'or te jaunit.',
        message_perso:`${userPrenom}, tu as une présence froide et élégante qui en impose sans forcer. Tes couleurs sont tes alliées naturelles.`,
        palette_pe:[{"nom": "Rose framboise", "hex": "#E06080"}, {"nom": "Bleu lavande", "hex": "#8090D0"}, {"nom": "Blanc froid", "hex": "#F8F8FF"}, {"nom": "Mauve clair", "hex": "#D0A8D0"}, {"nom": "Bleu acier clair", "hex": "#A0B8D0"}, {"nom": "Parme soutenu", "hex": "#B890C8"}, {"nom": "Lilas froid", "hex": "#C8B8E8"}, {"nom": "Rose fuchsia pâle", "hex": "#F0A0C8"}],
        palette_ah:[{"nom": "Framboise froid", "hex": "#C72060"}, {"nom": "Bleu acier", "hex": "#7090B0"}, {"nom": "Bordeaux rosé", "hex": "#A04060"}, {"nom": "Prune froid", "hex": "#906080"}, {"nom": "Mauve moyen", "hex": "#B070B0"}, {"nom": "Gris bleuté", "hex": "#8090A0"}, {"nom": "Rose fuchsia doux", "hex": "#D060A0"}, {"nom": "Bleu marine doux", "hex": "#506080"}]
      },
      // ── AUTOMNE ──────────────────────────────────────────────────────────
      'Automne Profond': {
        saison:'Automne Profond', emoji:'🍂', headline:'Riche, profonde, magnétiquement intense',
        description:`${userPrenom}, tu es l'Automne dans toute sa splendeur — les couleurs les plus riches et les plus profondes te vont comme une évidence. Tu as besoin de profondeur et de chaleur pour rayonner.`,
        palette:[
          {nom:'Bordeaux profond',hex:'#722F37',usage:'vêtements'},{nom:'Terracotta brûlé',hex:'#A0522D',usage:'vêtements'},
          {nom:'Chocolat chaud',hex:'#7B3F00',usage:'vêtements'},{nom:'Forêt profond',hex:'#2D4A1E',usage:'vêtements'},
          {nom:'Rouille intense',hex:'#B7410E',usage:'vêtements'},{nom:'Prune chaud',hex:'#5C2040',usage:'vêtements'},
          {nom:'Olive foncé',hex:'#556B2F',usage:'vêtements'},{nom:'Camel profond',hex:'#A07040',usage:'accessoires'},
          {nom:'Bronze doré',hex:'#8B6914',usage:'accessoires'},{nom:'Rouge brique',hex:'#CB4154',usage:'maquillage'},
          {nom:'Moutarde dorée',hex:'#C8A000',usage:'accessoires'},{nom:'Brun épicé',hex:'#7B4B2A',usage:'vêtements'}
        ],
        couleurs_yes:['Bordeaux','Terracotta brûlé','Chocolat','Forêt','Rouille','Prune chaud'],
        couleurs_no:['Rose bébé','Blanc pur','Bleu froid','Gris acier','Jaune pâle'],
        maquillage:'Fond de teint ambré ou doré profond. Lèvres bordeaux, brique ou terracotta foncé — c\'est là que ta bouche est la plus belle. Évite le nude qui t\'efface.',
        style_tip:'Les tons profonds monochrome sont ta force absolue. En curvy, un total look chocolat ou bordeaux profond avec des accessoires bronze te donne une présence magnétique inoubliable.',
        metal:'Or — exclusivement, dans les tons bronze et ambré.',
        message_perso:`${userPrenom}, ta beauté est d'une profondeur rare. Les couleurs intenses ne t'écrasent pas — elles te révèlent. Porte-les sans retenue.`,
        palette_pe:[{"nom": "Terracotta clair", "hex": "#E07050"}, {"nom": "Rouille vive", "hex": "#CB6D51"}, {"nom": "Camel moyen", "hex": "#C19A6B"}, {"nom": "Orange brûlé", "hex": "#CC5500"}, {"nom": "Moutarde vive", "hex": "#C4A000"}, {"nom": "Olive chaud", "hex": "#8B8040"}, {"nom": "Saumon doré", "hex": "#E8956A"}, {"nom": "Pêche foncée", "hex": "#D4826A"}],
        palette_ah:[{"nom": "Bordeaux profond", "hex": "#722F37"}, {"nom": "Chocolat chaud", "hex": "#7B3F00"}, {"nom": "Forêt profond", "hex": "#2D4A1E"}, {"nom": "Prune chaud", "hex": "#5C2040"}, {"nom": "Olive foncé", "hex": "#556B2F"}, {"nom": "Rouille intense", "hex": "#B7410E"}, {"nom": "Brun épicé", "hex": "#7B4B2A"}, {"nom": "Terracotta brûlé", "hex": "#A0522D"}]
      },
      'Automne Chaud': {
        saison:'Automne Chaud', emoji:'🔥', headline:'Chaude, ensoleillée, terriblement vivante',
        description:`${userPrenom}, tu es l'Automne dans sa version la plus lumineuse et chaude. Tes couleurs sont riches mais pas trop sombres — elles rayonnent d'une énergie dorée et terreuse irrésistible.`,
        palette:[
          {nom:'Terracotta vif',hex:'#C66B3B',usage:'vêtements'},{nom:'Rouille claire',hex:'#CB6D51',usage:'vêtements'},
          {nom:'Kaki doré',hex:'#8B8040',usage:'vêtements'},{nom:'Camel moyen',hex:'#C19A6B',usage:'vêtements'},
          {nom:'Orange brûlé',hex:'#CC5500',usage:'vêtements'},{nom:'Moutarde vive',hex:'#C4A000',usage:'accessoires'},
          {nom:'Brun cannelle',hex:'#964B00',usage:'vêtements'},{nom:'Vert sauge chaud',hex:'#7D8B6A',usage:'accessoires'},
          {nom:'Pêche foncée',hex:'#D4826A',usage:'maquillage'},{nom:'Tomate chaude',hex:'#CE3B28',usage:'maquillage'},
          {nom:'Ivoire doré',hex:'#F5ECD7',usage:'vêtements'},{nom:'Bronze cuivré',hex:'#B87333',usage:'accessoires'}
        ],
        couleurs_yes:['Terracotta','Rouille','Kaki doré','Camel','Orange brûlé','Moutarde'],
        couleurs_no:['Rose froid','Bleu glacé','Gris froid','Noir pur','Blanc froid'],
        maquillage:'Base dorée ou pêchée. Lèvres terracotta ou tomate chaude — jamais de rose froid. Blush pêche ou brique sur les pommettes.',
        style_tip:'Le mix terracotta + kaki + camel dans une même tenue est ta combinaison signature. En curvy, les matières texturées (daim, velours côtelé) dans tes tons chauds créent une silhouette riche et chic.',
        metal:'Or — doré ou cuivré, jamais argenté.',
        message_perso:`${userPrenom}, tu as cette chaleur naturelle qui attire les regards sans effort. Habille-toi dans tes tons dorés et laisse ta personnalité faire le reste.`,
        palette_pe:[{"nom": "Terracotta vif", "hex": "#C66B3B"}, {"nom": "Abricot chaud", "hex": "#F08040"}, {"nom": "Corail pêche", "hex": "#F4A460"}, {"nom": "Moutarde claire", "hex": "#DAA520"}, {"nom": "Sauge chaude", "hex": "#7D8B6A"}, {"nom": "Ivoire doré", "hex": "#F5ECD7"}, {"nom": "Pêche foncée", "hex": "#D4826A"}, {"nom": "Orange clair", "hex": "#F4A040"}],
        palette_ah:[{"nom": "Rouille claire", "hex": "#CB6D51"}, {"nom": "Kaki doré", "hex": "#8B8040"}, {"nom": "Brun cannelle", "hex": "#964B00"}, {"nom": "Orange brûlé", "hex": "#CC5500"}, {"nom": "Camel moyen", "hex": "#C19A6B"}, {"nom": "Vert sauge chaud", "hex": "#7D8B6A"}, {"nom": "Bronze cuivré", "hex": "#B87333"}, {"nom": "Tomate chaude", "hex": "#CE3B28"}]
      },
      'Automne Doux': {
        saison:'Automne Doux', emoji:'🍁', headline:'Douce et terreuse, élégamment naturelle',
        description:`${userPrenom}, tu combines la chaleur de l'Automne avec une douceur muted qui te rend unique. Tes couleurs sont sourdes, jamais criardes — une élégance naturelle et organique.`,
        palette:[
          {nom:'Brun rosé doux',hex:'#C09080',usage:'vêtements'},{nom:'Sauge grisé',hex:'#8FA880',usage:'vêtements'},
          {nom:'Camel rosé',hex:'#C8A890',usage:'vêtements'},{nom:'Terracotta poudré',hex:'#C88070',usage:'vêtements'},
          {nom:'Kaki grisé',hex:'#909070',usage:'vêtements'},{nom:'Rose terre',hex:'#C09088',usage:'vêtements'},
          {nom:'Vert mousse',hex:'#707850',usage:'accessoires'},{nom:'Beige chaud',hex:'#D4B896',usage:'vêtements'},
          {nom:'Brique douce',hex:'#B87060',usage:'maquillage'},{nom:'Rouille poudré',hex:'#C07860',usage:'maquillage'},
          {nom:'Bronze mat',hex:'#A08050',usage:'accessoires'},{nom:'Crème dorée',hex:'#EDD9C0',usage:'vêtements'}
        ],
        couleurs_yes:['Sauge','Camel rosé','Terracotta poudré','Kaki grisé','Brun rosé','Vert mousse'],
        couleurs_no:['Blanc pur froid','Couleurs fluo','Bleu froid','Noir pur','Rose froid'],
        maquillage:'Base nude dorée, très naturelle. Lèvres brique douce ou brun rosé — les tons muted sont ta signature. Jamais de rouge vif qui rompt ton harmonie.',
        style_tip:'Tes tons grisés et terreux te donnent une allure organique. En curvy, le beige-kaki-terracotta ensemble crée une silhouette harmonieuse.',
        metal:'Or mat ou bronze — jamais brillant, le côté patiné te va parfaitement.',
        message_perso:`${userPrenom}, ton style est celui des femmes qui n'ont pas besoin de crier pour être vues. Ta douceur terreuse est une élégance rare.`,
        palette_pe:[{"nom": "Camel rosé", "hex": "#C8A890"}, {"nom": "Sauge grisé", "hex": "#8FA880"}, {"nom": "Brun rosé doux", "hex": "#C09080"}, {"nom": "Beige chaud", "hex": "#D4B896"}, {"nom": "Kaki grisé clair", "hex": "#B0B090"}, {"nom": "Crème dorée", "hex": "#EDD9C0"}, {"nom": "Rose terre pâle", "hex": "#D0A898"}, {"nom": "Vert mousse clair", "hex": "#A0A870"}],
        palette_ah:[{"nom": "Terracotta poudré", "hex": "#C88070"}, {"nom": "Kaki grisé", "hex": "#909070"}, {"nom": "Vert mousse", "hex": "#707850"}, {"nom": "Brique douce", "hex": "#B87060"}, {"nom": "Rouille poudré", "hex": "#C07860"}, {"nom": "Bronze mat", "hex": "#A08050"}, {"nom": "Brun rosé moyen", "hex": "#A07868"}, {"nom": "Rose terre", "hex": "#C09088"}]
      },
      // ── HIVER ─────────────────────────────────────────────────────────────
      'Hiver Pur': {
        saison:'Hiver Pur', emoji:'❄️', headline:'Saisissante, contrastée, inoubliablement précise',
        description:`${userPrenom}, tu es l'Hiver dans toute sa puissance — le contraste et la netteté sont tes superpouvoir. Les couleurs intenses et pures te révèlent, les intermédiaires t'éteignent.`,
        palette:[
          {nom:'Blanc pur',hex:'#FFFFFF',usage:'vêtements'},{nom:'Noir intense',hex:'#0A0A0A',usage:'vêtements'},
          {nom:'Rouge cerise',hex:'#C00020',usage:'vêtements'},{nom:'Cobalt pur',hex:'#0047AB',usage:'vêtements'},
          {nom:'Fuchsia vif',hex:'#C2185B',usage:'vêtements'},{nom:'Émeraude froid',hex:'#008060',usage:'vêtements'},
          {nom:'Prune intense',hex:'#7B1FA2',usage:'vêtements'},{nom:'Marine profond',hex:'#001A40',usage:'vêtements'},
          {nom:'Bordeaux froid',hex:'#800030',usage:'maquillage'},{nom:'Rose choc',hex:'#E91E63',usage:'maquillage'},
          {nom:'Argent',hex:'#C0C8D0',usage:'accessoires'},{nom:'Anthracite',hex:'#404040',usage:'vêtements'}
        ],
        couleurs_yes:['Blanc pur','Noir','Rouge cerise','Cobalt','Fuchsia','Émeraude'],
        couleurs_no:['Camel','Orange','Pêche','Brun chaud','Beige','Kaki'],
        maquillage:'Teint porcelaine ou mat satiné — jamais bronzé. Lèvres rouge cerise, bordeaux froid ou fuchsia. C\'est le contraste lèvres/teint qui fait tout ton effet.',
        style_tip:'Le contraste est ton outil principal. Noir + blanc ou une couleur pure + noir : en curvy, cette stratégie crée une silhouette qui s\'impose naturellement dans toutes les pièces.',
        metal:'Argent — exclusivement. L\'or te jaunit et brise ton harmonie froide.',
        message_perso:`${userPrenom}, tu es la femme qu'on remarque en entrant dans une pièce. Ton profil Hiver Pur est l'un des plus puissants des 12 saisons — porte-le avec l'audace qu'il mérite.`,
        palette_pe:[{"nom": "Blanc pur", "hex": "#FFFFFF"}, {"nom": "Fuchsia vif", "hex": "#C2185B"}, {"nom": "Cobalt pur", "hex": "#0047AB"}, {"nom": "Rouge cerise", "hex": "#C00020"}, {"nom": "Émeraude froid", "hex": "#008060"}, {"nom": "Rose choc", "hex": "#E91E63"}, {"nom": "Bleu glacial", "hex": "#E8F4FF"}, {"nom": "Menthe vive", "hex": "#00C896"}],
        palette_ah:[{"nom": "Noir intense", "hex": "#0A0A0A"}, {"nom": "Marine profond", "hex": "#001A40"}, {"nom": "Prune intense", "hex": "#7B1FA2"}, {"nom": "Bordeaux froid", "hex": "#800030"}, {"nom": "Anthracite", "hex": "#404040"}, {"nom": "Rouge cerise", "hex": "#C00020"}, {"nom": "Argent", "hex": "#C0C8D0"}, {"nom": "Vert sapin froid", "hex": "#006040"}]
      },
      'Hiver Profond': {
        saison:'Hiver Profond', emoji:'🌑', headline:'Profonde, intense, magnétiquement sombre',
        description:`${userPrenom}, tu combines la froideur de l'Hiver avec une profondeur exceptionnelle. Les couleurs les plus sombres et les plus riches te font rayonner là où elles écraseraient n'importe qui d'autre.`,
        palette:[
          {nom:'Noir profond',hex:'#0A0A0A',usage:'vêtements'},{nom:'Bordeaux nuit',hex:'#4A0018',usage:'vêtements'},
          {nom:'Marine profond',hex:'#001020',usage:'vêtements'},{nom:'Prune nuit',hex:'#4B0082',usage:'vêtements'},
          {nom:'Chocolat froid',hex:'#3C1810',usage:'vêtements'},{nom:'Vert sapin foncé',hex:'#0D2B1A',usage:'vêtements'},
          {nom:'Gris anthracite',hex:'#2C2C2C',usage:'vêtements'},{nom:'Rouge grenat',hex:'#7C0A02',usage:'maquillage'},
          {nom:'Brun froid profond',hex:'#4A2820',usage:'vêtements'},{nom:'Bleu nuit',hex:'#003060',usage:'accessoires'},
          {nom:'Argent foncé',hex:'#909090',usage:'accessoires'},{nom:'Aubergine',hex:'#6C2A6A',usage:'vêtements'}
        ],
        couleurs_yes:['Noir profond','Bordeaux nuit','Marine','Prune','Vert sapin','Aubergine'],
        couleurs_no:['Pêche','Beige','Jaune','Orange','Rose pâle','Camel'],
        maquillage:'Teint mat très couvrant. Lèvres rouge grenat, bordeaux profond ou prune — les couleurs sombres te magnifient. Évite les nudes qui t\'effacent complètement.',
        style_tip:'Tu peux porter du noir total look sans paraître triste — c\'est l\'un de tes plus grands privilèges. En curvy, joue avec les textures dans le noir : mat + brillant + velours pour une silhouette sculpturale.',
        metal:'Argent et gunmetal — les tons sombres froids te correspondent parfaitement.',
        message_perso:`${userPrenom}, tu as une beauté profonde et rare que les couleurs claires ne savent pas mettre en valeur. L'intensité est ta zone de confort — habite-la pleinement.`,
        palette_pe:[{"nom": "Noir profond", "hex": "#0A0A0A"}, {"nom": "Bleu nuit", "hex": "#003060"}, {"nom": "Bordeaux nuit", "hex": "#4A0018"}, {"nom": "Émeraude froid", "hex": "#008060"}, {"nom": "Blanc pur", "hex": "#FFFFFF"}, {"nom": "Cobalt pur", "hex": "#0047AB"}, {"nom": "Bleu glacial", "hex": "#E8F4FF"}, {"nom": "Rouge cerise", "hex": "#C00020"}],
        palette_ah:[{"nom": "Noir profond", "hex": "#0A0A0A"}, {"nom": "Prune nuit", "hex": "#4B0082"}, {"nom": "Marine profond", "hex": "#001020"}, {"nom": "Vert sapin foncé", "hex": "#0D2B1A"}, {"nom": "Aubergine", "hex": "#6C2A6A"}, {"nom": "Bordeaux nuit", "hex": "#4A0018"}, {"nom": "Gris anthracite", "hex": "#2C2C2C"}, {"nom": "Brun froid profond", "hex": "#4A2820"}]
      },
      'Hiver Froid': {
        saison:'Hiver Froid', emoji:'🌨️', headline:'Froide, nette, élégamment affirmée',
        description:`${userPrenom}, tu es l'Hiver dans sa version la plus froide et nette, sans être forcément très foncée. Les couleurs froides claires ET foncées te vont — ce qui ne te va pas, c'est la chaleur.`,
        palette:[
          {nom:'Blanc pur froid',hex:'#F8F8FF',usage:'vêtements'},{nom:'Gris glacier',hex:'#808090',usage:'vêtements'},
          {nom:'Bleu acier froid',hex:'#4060A0',usage:'vêtements'},{nom:'Prune froid',hex:'#806080',usage:'vêtements'},
          {nom:'Bleu roi',hex:'#2040A0',usage:'vêtements'},{nom:'Rose fuchsia froid',hex:'#C02070',usage:'vêtements'},
          {nom:'Gris acier',hex:'#607080',usage:'vêtements'},{nom:'Marine froid',hex:'#203060',usage:'accessoires'},
          {nom:'Bordeaux froid',hex:'#802040',usage:'maquillage'},{nom:'Mauve froid',hex:'#9070A0',usage:'maquillage'},
          {nom:'Argent',hex:'#C8D0D8',usage:'accessoires'},{nom:'Anthracite bleuté',hex:'#384050',usage:'vêtements'}
        ],
        couleurs_yes:['Blanc froid','Bleu acier','Prune froid','Bleu roi','Fuchsia froid','Marine'],
        couleurs_no:['Camel','Terracotta','Brun chaud','Orange','Pêche','Vert kaki'],
        maquillage:'Base froide ou neutre froide — jamais orangée. Lèvres bordeaux froid ou mauve froid. Rouge à lèvres bleu-rouge, pas orange-rouge.',
        style_tip:'La sophistication froide est ta marque. En curvy, le bleu marine foncé ou gris anthracite des pieds à la tête crée une silhouette allongée et puissante — avec un accessoire argent pour la lumière.',
        metal:'Argent — absolument. Platine si possible.',
        message_perso:`${userPrenom}, ton élégance froide est naturelle et sans effort. Les couleurs froides te donnent une présence que les femmes chaudes ne peuvent pas imiter.`,
        palette_pe:[{"nom": "Blanc pur froid", "hex": "#F8F8FF"}, {"nom": "Bleu acier froid", "hex": "#4060A0"}, {"nom": "Rose fuchsia froid", "hex": "#C02070"}, {"nom": "Bleu roi", "hex": "#2040A0"}, {"nom": "Blanc glacial", "hex": "#EEF4FF"}, {"nom": "Lavande froide", "hex": "#C0B0E0"}, {"nom": "Menthe froide vive", "hex": "#80D0C0"}, {"nom": "Prune clair", "hex": "#A080B0"}],
        palette_ah:[{"nom": "Gris glacier", "hex": "#808090"}, {"nom": "Prune froid", "hex": "#806080"}, {"nom": "Gris acier", "hex": "#607080"}, {"nom": "Marine froid", "hex": "#203060"}, {"nom": "Bordeaux froid", "hex": "#802040"}, {"nom": "Mauve froid", "hex": "#9070A0"}, {"nom": "Anthracite bleuté", "hex": "#384050"}, {"nom": "Argent", "hex": "#C8D0D8"}]
      }
    };
    aiResults = fb[subSeason] || fb['Été Doux'];
    completeLoading();
    await new Promise(r=>setTimeout(r,700));
    renderResults();
  }
}

function renderResults() {
  document.getElementById('progress-fill').style.width='100%';
  const r = aiResults;

  // Hero — keep brand rose palette, just add subtle season tint
  document.getElementById('results-title').innerHTML = `${r.emoji} <em>${r.saison}</em>`;

  // Mapping saison PE -> equivalent AH
  var saisonMap = {
    'Printemps Lumineux': ['Hiver Pur',      'eclat vif et contraste fort'],
    'Printemps Chaud':    ['Automne Chaud',   'tons dores et chauds'],
    'Printemps Clair':    ['Ete Clair',       'legerte et douceur froide'],
    'Ete Doux':           ['Automne Doux',    'douceur poudree'],
    'Ete Clair':          ['Printemps Clair', 'legerete et fraicheur'],
    'Ete Froid':          ['Hiver Froid',     'nettete froide'],
    'Automne Profond':    ['Hiver Profond',   'profondeur intense'],
    'Automne Chaud':      ['Printemps Chaud', 'tons dores et chauds'],
    'Automne Doux':       ['Ete Doux',        'douceur terreuse'],
    'Hiver Pur':          ['Printemps Lumineux','eclat vif et contraste fort'],
    'Hiver Profond':      ['Automne Profond', 'profondeur intense'],
    'Hiver Froid':        ['Ete Froid',       'nettete froide']
  };
  var saisonInfo = saisonMap[r.saison] || ['', ''];
  var saisonOpp = saisonInfo[0];
  var saisonLien = saisonInfo[1];

  // Bloc explicatif apres le titre
  var explBloc = document.createElement('div');
  explBloc.style.cssText = 'background:#FDF6F8;border-left:3px solid var(--pink);padding:16px 18px;margin:20px auto 0 auto;border-radius:0 4px 4px 0;text-align:left;max-width:680px;width:100%;box-sizing:border-box';
  explBloc.innerHTML = [
    "<p style='font-family:Jost,sans-serif;font-size:11px;font-weight:500;letter-spacing:2px;text-transform:uppercase;color:var(--pink);margin:0 0 12px 0'>Ta saison et sa sœur</p>",
    "<p style='font-family:Cormorant Garamond,serif;font-size:16px;color:var(--gray);line-height:1.8;margin:0 0 12px 0'>",
    userPrenom + ", tu es <strong>" + r.saison + "</strong>",
    saisonOpp ? " et ta saison sœur est <strong>" + saisonOpp + "</strong>. Elles sont de la même famille de tons (<em>" + saisonLien + "</em>), mais nous te les avons déclinées en deux versions : une palette légère et lumineuse pour le Printemps/Été, et une palette riche et profonde pour l’Automne/Hiver." : ".",
    "</p>",
    "<p style='font-family:Cormorant Garamond,serif;font-size:16px;color:var(--gray);line-height:1.8;margin:0 0 12px 0'>Ces palettes correspondent aux couleurs qui te mettent le plus en valeur. Les déclinaisons de ta saison sœur te permettent d’arborer les nuances les plus flatteuses pour toi, quelle que soit la météo, les tendances ou la saison réelle.</p>",
    "<p style='font-family:Cormorant Garamond,serif;font-size:16px;color:var(--pink);font-style:italic;line-height:1.7;margin:0'>Tes deux palettes ci-dessous sont les nuances qui t’illumineront le plus. ✨</p>"
  ].join('');

  var heroSection = document.querySelector('.results-hero');
  if (heroSection) heroSection.appendChild(explBloc);
  document.getElementById('results-headline').textContent = r.headline;

  // Palette hero — garder les 6 premières couleurs PE comme aperçu
  const heroPalette = (r.palette_pe || r.palette || []).slice(0,6);
  document.getElementById('palette-row').innerHTML = heroPalette.map(p=>`
    <div class="palette-swatch-wrap">
      <svg class="palette-swatch" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" r="21" fill="${p.hex}" stroke="white" stroke-width="3"/></svg>
      <span class="palette-swatch-name">${p.nom}</span>
    </div>`).join('');

  // Body
  // Helper pour générer une rangée de swatches
  function swatchRow(palette) {
    return (palette||[]).map(p=>`
      <div class="palette-swatch-wrap">
        <svg class="palette-swatch" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" r="21" fill="${p.hex}" stroke="white" stroke-width="3"/></svg>
        <span class="palette-swatch-name">${p.nom}</span>
      </div>`).join('');
  }

  document.getElementById('results-body').innerHTML = `
    <div class="r-card">
      <h3>Bonjour <em>${userPrenom}</em> ✨</h3>
      <p class="r-content">${r.description}</p>
      <p class="r-content" style="margin-top:14px; color:var(--pink); font-style:italic;">${r.message_perso}</p>
    </div>

    <div class="r-card">
      <h3>🌸 Ta palette <em>Printemps / Été</em></h3>
      <p class="r-content" style="margin-bottom:16px;">Tes couleurs adaptées à ta colorimétrie.</p>

      <div class="palette-row" id="palette-pe" style="justify-content:flex-start; margin-bottom:0;">${swatchRow(r.palette_pe||r.palette)}</div>
    </div>

    <div class="r-card">
      <h3>🍂 Ta palette <em>Automne / Hiver</em></h3>
      <p class="r-content" style="margin-bottom:16px;">Tes couleurs profondes pour la saison froide.</p>
      <div class="palette-row" id="palette-ah" style="justify-content:flex-start; margin-bottom:0;">${swatchRow(r.palette_ah||r.palette)}</div>
    </div>

    <div class="r-card">
      <h3>Les couleurs qui t'<em>illuminent</em></h3>
      <p class="r-content" style="margin-bottom:12px;">Ces teintes magnifient naturellement ton teint, toute l'année.</p>
      <div class="r-tags">${(r.couleurs_yes||[]).map(c=>`<span class="r-tag yes">✓ ${c}</span>`).join('')}</div>
      <p class="r-content" style="margin-top:20px; margin-bottom:12px;">Ces couleurs ternissent ton éclat — à éviter au premier plan.</p>
      <div class="r-tags">${(r.couleurs_no||[]).map(c=>`<span class="r-tag no">✗ ${c}</span>`).join('')}</div>
    </div>

    <div class="r-card">
      <h3>Maquillage <em>idéal</em></h3>
      <p class="r-content">${r.maquillage}</p>
    </div>

    <div class="r-card">
      <h3>Ton conseil style <em>curvy</em></h3>
      <p class="r-content">${r.style_tip}</p>
    </div>

    <div class="r-card">
      <h3>Ton métal <em>signature</em></h3>
      <p class="r-content">${r.metal}</p>
      <div class="r-tags" style="margin-top:12px;"><span class="r-tag star">★ ${r.metal.split('—')[0].trim()}</span></div>
    </div>

        <div style="text-align:center; padding:40px 20px 20px;">
      <p style="font-family:'Cormorant Garamond',serif; font-size:19px; font-style:italic; color:var(--gray); margin-bottom:24px;">
        Telecharge ton analyse en PDF pour ne pas la perdre
      </p>
      <button onclick="downloadPDF()" style="background:var(--pink);color:white;border:none;border-radius:2px;padding:16px 40px;font-family:'Jost',sans-serif;font-size:12px;font-weight:500;letter-spacing:3px;text-transform:uppercase;cursor:pointer;box-shadow:0 6px 24px rgba(224,84,122,0.25);">
        Telecharger mon analyse
      </button>
    </div>
  `;

  // Coloriser toutes les nouvelles swatches

  showScreen('results');
}

// ═══════════════════════════════
// KLAVIYO + SHOPIFY REDIRECT
// ═══════════════════════════════
async function goToShop() {
  const btn = document.getElementById('cta-shop-btn');
  const status = document.getElementById('cta-status');
  btn.disabled = true;
  btn.textContent = 'Enregistrement en cours…';
  status.textContent = '';

  const { base: season } = computeSeason();
  const saison = aiResults ? aiResults.saison : subSeason;
  const colors = SEASON_SHOPIFY_COLORS[season] || [];

  // 1. Push to Klaviyo
  try {
    await klaviyoIdentify({
      email: userEmail,
      first_name: userPrenom,
      saison_colorimetrique: saison,
      palette_couleurs: (aiResults?.couleurs_yes || colors).join(', '),
    });
    status.textContent = '✓ Ton profil a bien été enregistré !';
  } catch(e) {
    // Silent fail — don't block the redirect
    console.warn('Klaviyo error:', e);
  }

  // 2. Build Shopify filter URL
  const params = new URLSearchParams();
  colors.forEach(c => params.append(CONFIG.SHOPIFY_COLOR_FILTER, c));
  const shopUrl = CONFIG.SHOPIFY_URL + '/collections/all?' + params.toString();

  // 3. Redirect after brief pause so user sees confirmation
  setTimeout(() => {
    window.location.href = shopUrl;
  }, 1200);
}

async function klaviyoIdentify(properties) {
  // Klaviyo Client API — identify profile + track event
  const endpoint = `https://a.klaviyo.com/client/profiles/?company_id=${CONFIG.KLAVIYO_PUBLIC_KEY}`;
  
  const payload = {
    data: {
      type: 'profile',
      attributes: {
        email: properties.email,
        first_name: properties.first_name,
        properties: {
          saison_colorimetrique: properties.saison_colorimetrique,
          palette_couleurs: properties.palette_couleurs,
          quiz_source: 'quiz-colorimetrie-lindisciplinee',
        }
      }
    }
  };

  const resp = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'revision': '2024-02-15',
    },
    body: JSON.stringify(payload),
  });

  if (!resp.ok && resp.status !== 409) {
    // 409 = profile already exists, that's fine
    throw new Error('Klaviyo error: ' + resp.status);
  }
}

// Boutons attachés inline dans le HTML
function subscribeToNewsletter(email, prenom) {
  var saison = (aiResults && aiResults.saison) ? aiResults.saison : '';
  fetch('https://a.klaviyo.com/client/subscriptions/?company_id=RyP4CJ', {
    method: 'POST',
    headers: { 'content-type': 'application/json', 'revision': '2023-12-15' },
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: email, first_name: prenom, properties: { saison_colorimetrique: saison } } } },
          custom_source: 'Quiz Colorimetrie'
        },
        relationships: { list: { data: { type: 'list', id: 'SYKr8N' } } }
      }
    })
  }).then(function(r){ console.log('Klaviyo:', r.status); })
    .catch(function(e){ console.warn('Klaviyo:', e); });
}


function downloadPDF() {
  var r = aiResults;
  if (!r) return;
  var peS = (r.palette_pe||[]).map(function(p){return '<div style="display:inline-block;text-align:center;margin:4px"><div style="width:44px;height:44px;border-radius:50%;background:'+p.hex+';border:2px solid white;box-shadow:0 2px 8px rgba(0,0,0,.1);margin:0 auto"></div><div style="font-size:10px;color:#5A4E52;max-width:52px;margin-top:4px">'+p.nom+'</div></div>';}).join('');
  var ahS = (r.palette_ah||[]).map(function(p){return '<div style="display:inline-block;text-align:center;margin:4px"><div style="width:44px;height:44px;border-radius:50%;background:'+p.hex+';border:2px solid white;box-shadow:0 2px 8px rgba(0,0,0,.1);margin:0 auto"></div><div style="font-size:10px;color:#5A4E52;max-width:52px;margin-top:4px">'+p.nom+'</div></div>';}).join('');
  var yes = (r.couleurs_yes||[]).map(function(c){return '<span style="background:#F9D6DF;color:#CC3D65;padding:5px 14px;border-radius:20px;font-size:13px;margin:3px;display:inline-block">'+c+'</span>';}).join('');
  var no  = (r.couleurs_no||[]).map(function(c){return '<span style="background:#F5F5F5;color:#AAA;padding:5px 14px;border-radius:20px;font-size:13px;margin:3px;display:inline-block;text-decoration:line-through">'+c+'</span>';}).join('');
  var html = '<!DOCTYPE html><html lang="fr"><head><meta charset="UTF-8"><title>Analyse - '+r.saison+'</title>'
    +'<link href="https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;1,400&family=Cormorant+Garamond:ital,wght@0,300;0,400;1,400&family=Jost:wght@300;400;500&display=swap" rel="stylesheet">'
    +'<style>*{margin:0;padding:0;box-sizing:border-box}body{font-family:Jost,sans-serif;padding:40px;max-width:700px;margin:0 auto;color:#1C1012}.s{margin-bottom:24px;padding:24px;border:1px solid #EDD8DC;border-radius:4px}h3{font-family:"Playfair Display",serif;font-size:18px;font-weight:400;margin-bottom:12px}em{color:#E0547A;font-style:italic}p{font-family:"Cormorant Garamond",serif;font-size:17px;line-height:1.7;color:#5A4E52}@media print{button{display:none}}</style>'
    +'</head><body>'
    +'<div style="text-align:center;padding:40px 0 32px;border-bottom:1px solid #EDD8DC;margin-bottom:32px">'
    +'<p style="font-size:11px;letter-spacing:5px;text-transform:uppercase;color:#E0547A;margin-bottom:16px">L\'Indisciplinee</p>'
    +'<h1 style="font-family:\'Playfair Display\',serif;font-size:48px;font-style:italic;color:#E0547A">'+r.emoji+' '+r.saison+'</h1>'
    +'<p style="font-family:\'Cormorant Garamond\',serif;font-size:20px;font-style:italic;color:#5A4E52;margin-top:10px">'+r.headline+'</p>'
    +'</div>'
    +'<div class="s"><h3>Bonjour <em>'+userPrenom+'</em></h3><p>'+r.description+'</p><p style="margin-top:12px;color:#E0547A;font-style:italic">'+r.message_perso+'</p></div>'
    +'<div class="s"><h3>Ta palette <em>Printemps / Ete</em></h3><div style="display:flex;flex-wrap:wrap">'+peS+'</div></div>'
    +'<div class="s"><h3>Ta palette <em>Automne / Hiver</em></h3><div style="display:flex;flex-wrap:wrap">'+ahS+'</div></div>'
    +'<div class="s"><h3>Couleurs</h3><div>'+yes+no+'</div></div>'
    +'<div class="s"><h3>Maquillage <em>ideal</em></h3><p>'+r.maquillage+'</p></div>'
    +'<div class="s"><h3>Conseil <em>curvy</em></h3><p>'+r.style_tip+'</p></div>'
    +'<div class="s"><h3>Metal <em>signature</em></h3><p>'+r.metal+'</p></div>'
    +'<div style="text-align:center;margin-top:32px;font-size:11px;color:#5A4E52;letter-spacing:2px;text-transform:uppercase">L\'Indisciplinee - lindisciplinee.fr</div>'
    +'</body></html>';
  var blob = new Blob([html], { type: 'text/html;charset=utf-8' });
  var url = URL.createObjectURL(blob);
  var a = document.createElement('a');
  a.href = url;
  a.download = 'mon-analyse-colorimetrique.html';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(function(){ URL.revokeObjectURL(url); }, 2000);
}